import Vue from 'vue'
import Router from 'vue-router'
import home from '../view/home.vue'
import service from '../view/service.vue'
import company from '../view/company.vue'

Vue.use(Router)


let router =
  new Router({
    routes: [
      {
        path: '/',
        name: 'home',
        component: home
      },
      {
        path: '/home',
        name: 'home',
        component: home
      },
      {
        path: '/services',
        name: 'services',
        component: service
      },
      {
        path: '/about',
        name: 'about',
        component: company
      }
    ]
  })
export default router

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js